import type { EggTierId } from '@/types/rewards';
import speckledSvg from '@/assets/rewards/eggs/speckled.svg';
import mossySvg from '@/assets/rewards/eggs/mossy.svg';
import crystalSvg from '@/assets/rewards/eggs/crystal.svg';
import mythicSvg from '@/assets/rewards/eggs/mythic.svg';

const EGG_SVGS: Record<EggTierId, string> = {
  speckled: speckledSvg,
  mossy: mossySvg,
  crystal: crystalSvg,
  mythic: mythicSvg,
};

interface EggSvgProps {
  tierId: EggTierId;
  size?: number;
  className?: string;
}

export function EggSvg({ tierId, size = 80, className = '' }: EggSvgProps) {
  return (
    <img
      src={EGG_SVGS[tierId]}
      alt=""
      aria-hidden="true"
      width={size}
      height={size * 1.25}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}
